import { create, clickable, collection, fillable, text, value, visitable } from 'ember-cli-page-object';
import { isChecked } from 'vagrant/test-support/ecpo-utils';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/edit'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  registry: value('[data-test-registry]'),
  name: value('[data-test-name]'),
  description: value('[data-test-description]'),
  isPrivate: isChecked('[data-test-visibility="private"]'),
  isPublic: isChecked('[data-test-visibility="public"]'),
  visibilityOptions: collection('[data-test-visibility]'),
  fillInName: fillable('[data-test-name]'),
  fillInDescription: fillable('[data-test-description]'),
  async setVisibility(val) {
    const opt = this.visibilityOptions.findOneBy('value', val);
    if (!opt) throw new Error(`No visibility option with value ${val}`);
    await opt.click();
  },
  update: clickable('[data-test-update]'),
  flash: flashMessage
});